module.exports = ['$translate', '$state', '$utils',
  function($translate, $state, $utils) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: require('views/components/attachment.html'),
      link: function(scope, ele, attr) {
        ele.on('click', function() {
          scope.goFileCenter()
        })
        return {}
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/compose/attachmentInfo.js